import axios from 'axios';

// AuthContextのlogoutをimportするため、後でexportする
let logoutHandler = null;
export const setLogoutHandler = (handler) => {
  logoutHandler = handler;
};

// Axiosインスタンス作成
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true,
});

// リクエスト時にBearerトークンを自動付与
api.interceptors.request.use(config => {
  const raw = localStorage.getItem('tokens');
  if (raw) {
    try {
      const tokens = JSON.parse(raw);
      if (tokens?.access) {
        config.headers.Authorization = `Bearer ${tokens.access}`;
      }
    } catch {
      // 不正なJSON — トークンを付与しない
    }
  }
  return config;
});

// 401エラー時にリフレッシュを試み、失敗したらログアウト
let isRefreshing = false;
let refreshQueue = [];

const processQueue = (error, token = null) => {
  refreshQueue.forEach(({ resolve, reject }) => {
    error ? reject(error) : resolve(token);
  });
  refreshQueue = [];
};

api.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !originalRequest.url.includes('/token/')
    ) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          refreshQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers.Authorization = `Bearer ${token}`;
          return api(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const raw = localStorage.getItem('tokens');
        const tokens = raw ? JSON.parse(raw) : null;

        if (!tokens?.refresh) {
          throw new Error('No refresh token');
        }

        const { data } = await axios.post(
          `${process.env.REACT_APP_API_URL}/token/refresh/`,
          { refresh: tokens.refresh }
        );

        const newTokens = {
          access: data.access,
          refresh: data.refresh || tokens.refresh,
        };
        localStorage.setItem('tokens', JSON.stringify(newTokens));

        processQueue(null, newTokens.access);
        originalRequest.headers.Authorization = `Bearer ${newTokens.access}`;
        return api(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        if (logoutHandler) logoutHandler();
        window.location.href = '/signin';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

// API関数
export const postLogin = (username, password) =>
  api.post('/token/', { username, password });

export const getSoftwareCategories = () =>
  api.get('/software/categories/');

export default api; 